module.exports = __webpack_public_path__ + "static/report-fraud-20595b3d546e477181ace6f88fcc5b64.png";